import React, { useEffect, useState } from "react";
import "./App.css";
import { SERVER_HOST, THEME_0, dataContext } from "./utils/constants";
import Dashboard from "./components/Dashboard";
import LoginForm from "./components/LoginForm";
import Loader from "./components/Loader";

let allSettings = {};

export default function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [userId, setUserId] = useState(null);
    const [username, setUsername] = useState("");
    const [userRights, setUserRights] = useState({});
    const [isAdmin, setIsAdmin] = useState(0);

    const changeTheme = (theme) => {
        let themeArray = Object.entries(theme);

        for (let i = 0; i < themeArray.length; i++) {
            document.documentElement.style.setProperty(
                themeArray[i][0],
                themeArray[i][1]
            );
        }
    };

    const getSettings = () => {
        let userSettings = localStorage.getItem(username);
        if (userSettings)
            allSettings = { ...allSettings, ...JSON.parse(userSettings) };
        return allSettings;
    };

    const setSettings = (data) => {
        allSettings = { ...allSettings, ...data };
        if (username && allSettings) {
            localStorage.setItem(username, JSON.stringify(allSettings));
        }
    };

    useEffect(() => {
        changeTheme(THEME_0);
        const checkSession = async () => {
            try {
                const response = await fetch(SERVER_HOST, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify({ action: "check_session" }),
                });

                const data = await response.json();

                if (data.status === "logged_in") {
                    setUsername(data.username);
                    setUserId(data.user_id);
                    setUserRights(data.userRights);
                    setIsAdmin(data.urAdmin);
                    setIsAuthenticated(true);
                    let userSettings = localStorage.getItem(data.username);
                    if (userSettings) userSettings = JSON.parse(userSettings);
                    else userSettings = undefined;
                    if (userSettings) setSettings(userSettings);
                } else {
                    setIsAuthenticated(false);
                }
            } catch (error) {
                setIsAuthenticated(false);
            }
        };

        checkSession();
        // eslint-disable-next-line
    }, []);

    if (isAuthenticated === null) {
        return <Loader />;
    }

    return isAuthenticated ? (
        <dataContext.Provider
            value={{
                user: {
                    id: userId,
                    username: username,
                    userRights: userRights,
                    isAdmin: isAdmin,
                },
                setSettings: setSettings,
                getSettings: getSettings,
            }}
        >
            <Dashboard />
        </dataContext.Provider>
    ) : (
        <LoginForm />
    );
}
